import {
  // FETCH_QR_CODE,
  // FETCH_QR_CODE_FAILED,
  // FETCH_QR_CODE_SUCCEED,
  WAIT_FOR_AUTH,
  WAIT_FOR_AUTH_FAILED,
  WAIT_FOR_AUTH_SUCCEED,
  REGISTER,
  REGISTER_SUCCEED,
  REGISTER_FAILED, LOGIN_NORMAL, LOGIN_NORMAL_SUCCEED, LOGIN_NORMAL_FAILED,
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCEED,
  VERIFY_EMAIL_FAILED,
  LOGOUT,
  LOGOUT_SUCCEED,
  LOGOUT_FAILED,
  LOGIN_QR_1,
  LOGIN_QR_1_SUCCEED,
  LOGIN_QR_1_FAILED,
  LOGIN_QR_2,
  LOGIN_QR_2_SUCCEED,
  LOGIN_QR_2_FAILED,
  LOGIN_QR_3,
  LOGIN_QR_3_SUCCEED,
  LOGIN_QR_3_FAILED, LOGIN_QR_SUCCEED,
  VERIFY_WITHDRAWAL,
  VERIFY_WITHDRAWAL_SUCCEED,
  VERIFY_WITHDRAWAL_FAILED,
} from './action_types';

export default {
  // fetchQRcodeAction: (data) => {
  // 	return {
  // 		type: FETCH_QR_CODE,
  // 		params: {
  // 			data
  // 		}
  // 	}
  // },
  // fetchQRcodeActionSucceed: (data) => {
  // 	return {
  // 		type: FETCH_QR_CODE_SUCCEED,
  // 		params: {
  // 			data
  // 		}
  // 	}
  // },
  // fetchQRcodeActionFailed: (err) => {
  // 	return {
  // 		type: FETCH_QR_CODE_FAILED,
  // 		err
  // 	}
  // },

  waitForAuthAction: (data) => ({
    type: WAIT_FOR_AUTH,
    params: {
      data,
    },
  }),
  waitForAuthActionSucceed: (data) => ({
    type: WAIT_FOR_AUTH_SUCCEED,
    params: {
      data,
    },
  }),
  waitForAuthActionFailed: (err) => ({
    type: WAIT_FOR_AUTH_FAILED,
    err,
  }),

  register: (data) => ({
    type: REGISTER,
    params: {
      data,
    },
  }),
  registerSucceed: (data) => ({
    type: REGISTER_SUCCEED,
    params: {
      data,
    },
  }),
  registerFailed: (err) => ({
    type: REGISTER_FAILED,
    err,
  }),
  loginNormal: (data) => ({
    type: LOGIN_NORMAL,
    params: {
      data,
    },
  }),
  loginNormalSucceed: (data) => ({
    type: LOGIN_NORMAL_SUCCEED,
    params: {
      data,
    },
  }),
  loginNormalFailed: (err) => ({
    type: LOGIN_NORMAL_FAILED,
    err,
  }),
  loginQRSucceed: (data) => ({
    type: LOGIN_QR_SUCCEED,
    params: {
      data,
    },
  }),
  loginQR1: (data) => ({
    type: LOGIN_QR_1,
    params: {
      data,
    },
  }),
  loginQR1Succeed: (data) => ({
    type: LOGIN_QR_1_SUCCEED,
    params: {
      data,
    },
  }),
  loginQR1Failed: (err) => ({
    type: LOGIN_QR_1_FAILED,
    err,
  }),
  loginQR2: (data) => ({
    type: LOGIN_QR_2,
    params: {
      data,
    },
  }),
  loginQR2Succeed: (data) => ({
    type: LOGIN_QR_2_SUCCEED,
    params: {
      data,
    },
  }),
  loginQR2Failed: (err) => ({
    type: LOGIN_QR_2_FAILED,
    err,
  }),
  loginQR3: (data) => ({
    type: LOGIN_QR_3,
    params: {
      data,
    },
  }),
  loginQR3Succeed: (data) => ({
    type: LOGIN_QR_3_SUCCEED,
    params: {
      data,
    },
  }),
  loginQR3Failed: (err) => ({
    type: LOGIN_QR_3_FAILED,
    err,
  }),
  logout: (data) => ({
    type: LOGOUT,
    params: {
      data,
    },
  }),
  logoutSucceed: (data) => ({
    type: LOGOUT_SUCCEED,
    params: {
      data,
    },
  }),
  logoutFailed: (err) => ({
    type: LOGOUT_FAILED,
    err,
  }),

  verifyEmail: (data) => ({
    type: VERIFY_EMAIL,
    params: {
      data,
    },
  }),
  verifyEmailSucceed: (data) => ({
    type: VERIFY_EMAIL_SUCCEED,
    params: {
      data,
    },
  }),
  verifyEmailFailed: (err) => ({
    type: VERIFY_EMAIL_FAILED,
    err,
  }),
};
